// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"80fc3a02","279":"60167b96","294":"faa91822","377":"fff7a779","586":"55d94741","732":"8d9e344c","874":"163414a0","900":"049f2007"}[chunkId] + ".chunk.js";
};